var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-binnacle" },
    [
      _c(
        "app-timeline",
        _vm._l(_vm.binnacleFile, function(binnacle) {
          return _c(
            "app-timeline-item",
            {
              key: binnacle.bitacoraId,
              attrs: {
                icon: "InfoIcon",
                variant: _vm.getSeverity(binnacle.severidad)
              }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
                },
                [
                  _c("h6", [_vm._v(_vm._s(binnacle.usuarioNombre))]),
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("dateCompleteFormat")(binnacle.fecha)) +
                        " "
                    )
                  ])
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
                },
                [
                  _c("p", [_vm._v(_vm._s(binnacle.mensaje))]),
                  _c("div", { staticClass: "mb-1 mb-sm-0" }, [
                    _c(
                      "div",
                      [
                        binnacle.tipoVista == -1 || binnacle.tipoVista == 0
                          ? _c("b-avatar", {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass: "mr-50",
                              attrs: {
                                title: "Registro Visible solo para Admin",
                                text: "O",
                                size: "24",
                                icon: "eye-slash-fill",
                                variant: "secondary"
                              }
                            })
                          : _vm._e(),
                        _c("b-avatar", {
                          directives: [
                            {
                              name: "has-permission",
                              rawName: "v-has-permission",
                              value: "FEB99",
                              expression: "'FEB99'"
                            },
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              modifiers: { hover: true }
                            }
                          ],
                          staticClass: "mr-50 add-code",
                          attrs: {
                            title: "Copiar Seguimiento",
                            text: "S",
                            size: "24",
                            icon: "bug",
                            variant: "success"
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.copyToClipboard(binnacle.seguimientoId)
                            }
                          }
                        })
                      ],
                      1
                    )
                  ])
                ]
              )
            ]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }